import * as React from 'react';
import { Fragment } from 'react';
import Pagination from '../components/Pagination';
import {
	AutocompleteInput,
	BulkActionProps,
	BulkDeleteButton,
	DateInput,
	List,
	ListProps,
	ReferenceInput,
	TextInput
} from 'react-admin';
import { ProductList } from './ProductList';
import { ProductDatagrid } from './ProductDatagrid';
import { Theme, useMediaQuery } from '@material-ui/core';
import { ExportField, generateExporter } from '../util/Exporter';
import { Product } from './Product';

export * from './Product';
export * from './ProductCreate';
export * from './ProductDatagrid';
export * from './ProductEdit';
export * from './ProductList';
export * from './ProductShow';

const ProductsBulkActionButtons = (props: BulkActionProps) => (
	<Fragment>
		<BulkDeleteButton {...props} undoable={false}/>
	</Fragment>
);

export const exportFields: ExportField[] = [
	{ key: 'id', header: 'ID' },
	{ key: 'featuredImageUrl', header: 'Feature image' },
	{ key: 'name', header: 'Name' },
	{ key: 'price', header: 'Price' },
	{ key: 'description', header: 'Description' },
	{ key: 'category.name', header: 'Category' },
	{ key: 'link', header: 'Link' },
	{ key: 'organization.name', header: 'Organization' }
];

export const ProductsData = (props: ListProps): React.ReactElement => {
	const isXSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('xs'));
	const exportDataMapper = (entity: Product) => entity;

	const productsFilter = [
		<TextInput source="name" alwaysOn label="SEARCH"/>,
		<ReferenceInput
			step={1}
			label="CATEGORY"
			source="categoryId" reference="product-categories"
			alwaysOn
		>
			<AutocompleteInput optionText="name"/>
		</ReferenceInput>,
		<DateInput source="from__createdAt" label="FROM_CREATED_AT"
		           alwaysOn/>,
		<DateInput source="to__createdAt" label="TO_CREATED_AT"
		           alwaysOn/>
	];

	return (
		<Fragment>
			<List
				exporter={generateExporter('מוצרים', exportFields, exportDataMapper)}
				{...props}
				filters={productsFilter}
				bulkActionButtons={<ProductsBulkActionButtons/>}
				title="PRODUCTS"
				sort={{ field: '_createdAt', order: 'DESC' }}
				perPage={20}
				pagination={<Pagination/>}
			>
				{isXSmall ? <ProductList/> : <ProductDatagrid/>}
			</List>
		</Fragment>
	);
};
